import { IconRenderer } from 'braid-design-system';
import { useEffect, useRef } from 'react';
import * as styles from './SearchSpinner.css';

export const SearchSpinner = ({ isLoading }: { isLoading: boolean }) => {
  const state = isLoading ? 'loading' : 'not-loading';
  const animationRef = useRef<Animation | null>(null);
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    const spinner = svgRef.current?.querySelector('circle');
    if (!spinner) {
      return;
    }

    if (isLoading) {
      if (!animationRef.current) {
        animationRef.current = spinner.animate(
          [{ transform: 'rotate(180deg)' }, { transform: 'rotate(540deg)' }],
          {
            duration: 1500,
            iterations: Infinity,
            easing: 'cubic-bezier(.37, .77, .8, .37)',
          },
        );
      }
    } else {
      const effectiveTransform = window.getComputedStyle(spinner).transform;
      if (effectiveTransform) {
        spinner.style.transform = effectiveTransform;
      }

      animationRef.current?.cancel();
      animationRef.current = null;
    }
  }, [isLoading]);

  return (
    <IconRenderer>
      {({ className }) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 26 26"
          className={className}
          focusable="false"
          fill="none"
          stroke="currentColor"
          ref={svgRef}
        >
          <circle cx="11" cy="11" r="9.5" className={styles.spinner[state]} />
          <line
            x1="18"
            y1="18"
            x2="24"
            y2="24"
            strokeWidth="3"
            className={styles.handle[state]}
          />
        </svg>
      )}
    </IconRenderer>
  );
};
